export interface IconProps {
  className?: string;
}

function strokeProps(className?: string) {
  return {
    className,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: 'false' as const,
  };
}

function fillProps(className?: string) {
  return {
    className,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    'aria-hidden': true,
    focusable: 'false' as const,
  };
}

export function MenuIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M4 7h16M4 12h16M4 17h10" />
    </svg>
  );
}

export function StatsIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M5 19V13M10 19V8M15 19V11M20 19V5" />
    </svg>
  );
}

export function CalendarIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
      <path d="M8 3v4M16 3v4M3.5 10h17" />
      <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function FlameIcon({ className }: IconProps) {
  return (
    <svg {...fillProps(className)}>
      <path d="M13.5 2.1c.4 2.3-.4 3.8-1.7 5.1-1.4 1.5-3 2.9-3.7 5.2-1.1 3.7 1.1 7.6 4.8 8.6.4.1.8-.3.6-.7-.8-1.6-.9-3.1.3-4.5.6-.7 1-1.5 1.2-2.3.1-.4.6-.5.9-.2 1.9 2 2.5 4.2 1.8 6.5-.1.4.3.8.7.6 2.6-1.2 4.1-3.8 4.1-6.7 0-3.7-2.2-6.5-4.8-8.6-1-.9-2.4-1.7-3.7-2.6-.3-.2-.6 0-.5.4z" />
    </svg>
  );
}

export function SparkIcon({ className }: IconProps) {
  return (
    <svg {...fillProps(className)}>
      <path d="M12 2.5l1.9 6.6 6.6 1.9-6.6 1.9L12 19.5l-1.9-6.6L3.5 11l6.6-1.9z" />
    </svg>
  );
}

export function HexagonIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M12 2.6l8.2 4.7v9.4L12 21.4l-8.2-4.7V7.3z" />
    </svg>
  );
}

export function ShareIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M12 3v12" />
      <path d="M8.5 6.5L12 3l3.5 3.5" />
      <path d="M6 12H5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-1" />
    </svg>
  );
}

export function ChevronRightIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M9.5 5.5l6.5 6.5-6.5 6.5" />
    </svg>
  );
}

export function BulbIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 3a6 6 0 0 0-3.6 10.8c.6.5 1 1.2 1.1 2h5c.1-.8.5-1.5 1.1-2A6 6 0 0 0 12 3z" />
    </svg>
  );
}

export function QuestionIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.7.3-1 .9-1 1.6v.4" />
      <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function BackspaceIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps(className)}>
      <path d="M9 5h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6-7z" />
      <path d="M12.5 9.5l5 5M17.5 9.5l-5 5" />
    </svg>
  );
}
